<div class="new-registration-container">
  <form (submit)="submitFormData()" [formGroup]="userFormGroup" class="home-container">
    <div class="header-section">
      <div class="title">{{ 'app.user-form.registration' | translate }}</div>
      <i (click)="closeDialog()" class="pi pi-times icon-buttons"></i>
    </div>
    <div class="content-section">
      <div class="field-rows">
        <input
          class="ui-input pInputText input-field"
          formControlName="email"
          id="register-input-email"
          pInputText
          placeholder="{{ 'app.user-form.email' | translate }}"
          size="30"
          type="text" />
      </div>
      <div class="field-rows">
        <input
          class="ui-input pInputText input-field"
          formControlName="password"
          id="register-input-password"
          pPassword
          placeholder="{{ 'app.user-form.password' | translate }}"
          size="30"
          type="password"
          [showPassword]="showPasswordOne"
          [feedback]="false" />
        <span class="show-password-container">
          <i [ngClass]="showPasswordOne ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPasswordOne = !showPasswordOne"></i>
        </span>
      </div>
      <div class="field-rows">
        <input
          class="ui-input pInputText input-field"
          formControlName="confirmPassword"
          id="register-input-repeat-password"
          pPassword
          [showPassword]="showPasswordTwo"
          placeholder="{{ 'app.user-form.repeat-password' | translate }}"
          size="30"
          type="password" />
        <span class="show-password-container">
          <i [ngClass]="showPasswordTwo ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPasswordTwo = !showPasswordTwo"></i>
        </span>
      </div>

      <div class="field-rows" *ngIf="!userRole">
        <div class="ui-g-6 p-field-radiobutton">
          <p-radioButton formControlName="role" name="role" value="technician"></p-radioButton>
          <label>{{ 'app.user-form.technician' | translate }}</label>
        </div>
        <div class="ui-g-6 p-field-radiobutton">
          <p-radioButton formControlName="role" name="role" value="user"></p-radioButton>
          <label>{{ 'app.user-form.user' | translate }}</label>
        </div>
      </div>

      <div class="registration-submit-button-section">
        <div class="registration-checkbox">
          <p-checkbox binary="true" class="acceptPolicy-checkbox" formControlName="acceptPolicy" id="register-checkbox-policy"></p-checkbox>
          <label>
            <span>{{ 'app.user-form.registration-checkbox-text' | translate }}</span>
            (
            <span (click)="showTerms()" class="link">{{ 'app.user-form.registration-data-protection' | translate }}</span>
            )
          </label>
        </div>
        <p-button
          [disabled]="disableSubmitButton"
          [label]="'app.user-form.registration-button' | translate"
          class="full-width-button register-button"
          icon="{{ isLoading ? 'pi pi-spin pi-spinner' : 'null' }}"
          iconPos="right"
          id="register-btn-submit"
          type="submit"></p-button>
      </div>
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage | translate }}</div>
      <div *ngIf="successMessage" class="success-message">{{ successMessage | translate }}</div>

      <div class="footer">
        <span class="registration-section">
          <div>{{ 'app.user-form.goto-login1' | translate }}</div>
          <div>
            {{ 'app.user-form.goto-login2' | translate }}
            <span (click)="showLoginForm()" class="link-text" id="register-link-login">{{ appLabels.login }}</span>
          </div>
        </span>
      </div>
    </div>
  </form>
</div>
<app-display-terms [(displayTerms)]="displayTerms"></app-display-terms>
